import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

export class UyumsoftService {
    /** Göndermeden önce fatura e-Fatura mı e-Arşiv mi gidecek; hiçbir şey göndermez (17.10.2026). */
    static async faturaTuruOnizle(_invoiceId: string) {
        try {
            var inputObj = {
                invoiceId: _invoiceId,
            };

            console.log('SERVICE CALL - faturaTuruOnizle', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/FaturaTuruOnizle', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async sendInvoice(_invoiceId: string, _sendToGib: boolean) {
        try {
            var inputObj = {
                invoiceId: _invoiceId,
                sendToGib: _sendToGib
            };

            console.log('SERVICE CALL - sendInvoice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/sendInvoice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async saveAsDraftIrsaliye(_ambarId: string, _sendToGib: boolean) {
        try {
            var inputObj = {
                ambarId: _ambarId,
                sendToGib: _sendToGib
            };

            console.log('SERVICE CALL - saveAsDraftIrsaliye', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/saveAsDraftIrsaliye', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /**
     * Liste açılınca ekrandaki belgelerin Uyumsoft durumunu arkada yeniler (07.10.2026). Çağıran beklemez;
     * hata olursa sessizce geçilir, liste etkilenmez. Güncel durum bir sonraki yenilemede görünür.
     */
    static refreshStatusesArkada(_invoiceIds: string[], _ambarIds: string[]) {
        if (_invoiceIds.length == 0 && _ambarIds.length == 0)
            return;

        axios.post(Helpers.getEndpoint() + '/Uyumsoft/RefreshStatuses', { invoiceIds: _invoiceIds, ambarIds: _ambarIds })
            .catch(() => { /* sessiz: liste ekranını etkilemesin */ });
    }

    static async moveToDraftIrsaliye(_ambarId: string) {
        try {
            var inputObj = {
                ambarId: _ambarId,
            };

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/moveToDraftIrsaliye', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async cancelDraftIrsaliye(_ambarId: string) {
        try {
            var inputObj = {
                ambarId: _ambarId,
            };

            console.log('SERVICE CALL - cancelDraftIrsaliye', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/cancelDraftIrsaliye', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Uyumsoft'ta hataya dusen faturayi taslaga cevirir; numara korunur (07.10.2026). */
    static async moveToDraftInvoice(_invoiceId: string) {
        try {
            var inputObj = {
                invoiceId: _invoiceId,
            };

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/moveToDraftInvoice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Gönderilmiş e-Arşiv faturasını Uyumsoft'ta iptal eder (17.10.2026). */
    static async cancelEArsivInvoice(_invoiceId: string) {
        try {
            var inputObj = {
                invoiceId: _invoiceId,
            };

            console.log('SERVICE CALL - cancelEArsivInvoice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/CancelEArsivInvoice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async cancelDraftInvoice(_invoiceId: string) {
        try {
            var inputObj = {
                invoiceId: _invoiceId,
            };

            console.log('SERVICE CALL - cancelDraftInvoice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Uyumsoft/cancelDraftInvoice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

}